import cn from 'classnames/bind';
import Link from 'next/link';
import { Text } from 'ui';
import { getArticleHref } from 'utils/links';

import s from './ExploreBlogTypesSection.module.scss';

const cx = cn.bind(s);

export default function ExploreBlogTypesSection ({items, isLanding}) {
  return (
    <div className={cx('exploreBlock')}>
      <Text as="h4">
        Explore this type
      </Text>
      <ul className={cx('exploreBlockList')}>
        {items.map((item) => (
          <li
            key={item.slug}
            className={cx('exploreBlockItem')}
          >
            <Link
              href={getArticleHref(item.slug, {
                isLanding,
              })}
              className={cx('exploreBlockLink')}
              target="_blank"
              rel="noopener noreferrer">

              {item.title}

            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}